import React from 'react';
import { Frame, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const EmailSequence = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <Frame
      align={Frame.ALIGNMENTS.TOP_CENTER}
      background={SageTokens.COLOR_SLIDERS.GREY_200}
      style={{
        padding: breakpoints.sm ? undefined : '0 100px',
        height: '100%',
      }}
    >
      <Frame
        align={Frame.ALIGNMENTS.TOP_CENTER}
        background={SageTokens.COLOR_SLIDERS.WHITE}
        gap={Frame.GAPS.NONE}
        style={{ height: '100%' }}
      >
        <Frame className={hideOrExpandSection(1)} padding={Frame.PADDINGS.MD}>
          <MockItem
            color={SageTokens.COLOR_PALETTE.PRIMARY_100}
            height={12}
            width={87}
          />
        </Frame>
        <Frame
          background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
          className={hideOrExpandSection(1)}
          style={{ height: 180 }}
        />
        <Frame padding={Frame.PADDINGS.XL}>
          <MockItem
            color={SageTokens.COLOR_PALETTE.PRIMARY_200}
            height={12}
            width="36%"
          />
          <Frame gap={Frame.GAPS.SM}>
            <MockItem height={12} width="100%" />
            <MockItem height={12} width="86%" />
            <MockItem height={12} width="92%" />
            <MockItem height={12} width="82%" />
          </Frame>
          <Frame align={Frame.ALIGNMENTS.CENTER_CENTER}>
            <div
              style={{
                backgroundColor: SageTokens.COLOR_PALETTE.PRIMARY_300,
                borderRadius: 6,
                color: SageTokens.COLOR_PALETTE.WHITE,
                padding: '6px 16px',
              }}
            >
              Purchase now
            </div>
          </Frame>
        </Frame>
        <Frame
          direction={Frame.DIRECTIONS.HORIZONTAL}
          padding={Frame.PADDINGS.MD}
        >
          <Frame
            background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
            className={hideOrExpandSection(3)}
            style={{ height: '100%' }}
          />
          <Frame
            className={hideOrExpandSection(2)}
            gap={Frame.GAPS.SM}
            padding={Frame.PADDINGS.MD}
          >
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="100%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="69%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="83%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="50%"
            />
          </Frame>
        </Frame>
        <Frame
          direction={Frame.DIRECTIONS.HORIZONTAL}
          padding={Frame.PADDINGS.MD}
        >
          <Frame
            className={hideOrExpandSection(1)}
            gap={Frame.GAPS.SM}
            padding={Frame.PADDINGS.MD}
          >
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="100%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="69%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="83%"
            />
            <MockItem
              color={SageTokens.COLOR_PALETTE.PRIMARY_100}
              height={12}
              width="50%"
            />
          </Frame>
          <Frame
            background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
            className={hideOrExpandSection(3)}
            style={{ height: '100%' }}
          />
        </Frame>
      </Frame>
    </Frame>
  );
};

EmailSequence.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
